import React, { useState, useEffect } from 'react';
import axios from 'axios'

export default function SettingsJs(props){
    // constructor(props) {
    //     super(props)
    //     state = {
    //         showPopUp: false,
    //         cdnInput: '',
    //         jsCdnList: [], 
    //         externalCdnList: []
    //     }
    //     cdnInputHandler = cdnInputHandler.bind(this)
    //     showPopUp = showPopUp.bind(this)
    //     getExternalCdnList = getExternalCdnList.bind(this)
    // }

    const [state, setState] = useState({
        showPopUp: false,
        cdnInput: '',
        jsCdnList: [], 
        externalCdnList: []
    })

    //// ON CLICK OUTSIDE OF INPUT OR EXTERNAL CDN ELEMENT
    // componentWillMount() {
    //     document.addEventListener('mousedown', clearExternalResults, false)
    // }

    useEffect(() => {
            document.addEventListener('mousedown', clearExternalResults, false)
        return () => {
            document.removeEventListener('mousedown', clearExternalResults, false)
        }
    },[])
    // componentWillUnmount() {
    //     document.removeEventListener('mousedown', clearExternalResults, false)
    // }

    const clearExternalResults = (e) => {
        // if both refs arent being interacted with clear external cdn list
        // if( !results.contains(e.target) && !input.contains(e.target)) {
        //     setState({externalCdnList: []})
        // }
    }
    ///////////
    const showPopUp = () => {
        setState({showPopUp:!state.showPopUp})
    }

    const jsCdnSelectHandler=(data) => {
        props.jsCdnSelectHandler(data)
        setState({externalCdnList: [], cdnInput: ''})
    }

    const cdnInputHandler = (value) => {
        setState({cdnInput: value})
        getExternalCdnList()
    }

    const getExternalCdnList = () => {
        axios.get(`/api/pen/searchcdn/js?search=${state.cdnInput}`)
            .then( res => {
                setState({
                    externalCdnList: res.data.filter(element => {
                        return props.jsCdnList.indexOf(element.latest) === -1
                    })
                })
            })
            .catch(console.error)
    }


        const externalCdnList = state.externalCdnList.map( cdn => {
            return(
                <div key={cdn.name} onClick={() => jsCdnSelectHandler(cdn)} className="pen-settings-cdn-element">
                    <div className="cdn-element-name-version-container">
                        <div>
                            {cdn.name}
                        </div>
                        <div>
                            {cdn.version}
                        </div>
                    </div>
                    <div className="cdn-element-description" >{cdn.description}</div>
                </div>
            )
        })
        const cdnList = props.jsCdnList.map( item => {
            return (
                <div key={item} className="pen-settings-cdn-selected-element-container">
                    <div onClick={() => props.removeJsCdn(item)} className="pen-settings-cdn-selected-element-remove">x</div>
                    <div className="pen-settings-cdn-selected-element">
                        {item}
                    </div>
                </div>
            )
        })
        return (
            <div className="pen-settings-interface">
                <div onClick={showPopUp} className={`popup${state.showPopUp ? ' show-popup' : ""}`}>?</div>
                <h3 className="pen-settings-heading">Add External Scripts</h3> 
                <p className="pen-settings-description">Any URL's added here will be added as {"<script>"}s in order, and run before the JavaScript in the editor. You can use the URL of any other Pen and it will include the JavaScript from that Pen.</p>
                <div ref={input => input = input} className="pen-settings-input-container highlight">
                    <div className="pen-settings-input-icon">
                        <i 
                        style={{
                            fontSize: 20, 
                            color: '#535557',
                            marginLeft: 10,
                            marginTop:15,
                            left: 15, 
                            top: 15}} 
                            className="fa fa-search"></i>
                    </div>
                    <input 
                        placeholder="Add CDNjs (jQuery, Lodash, React, momentjs, Ember...)"
                        className="pen-settings-input" 
                        value={state.cdnInput} 
                        onChange={(event) => cdnInputHandler(event.target.value)} type="text"/>
                </div>
                <div ref={results => results = results} className="pen-settings-cdn-results-container">
                    {externalCdnList}
                </div>
                <div className="pen-settings-cdn-selected-container">
                    {cdnList}
                </div>
            </div>
        )
    }



// WEBPACK FOOTER //
// ./src/components/PenSettings/SettingsJS.js